export const TIPO_PRESTAMO = {
  CONCEDIDO: 1,
  RECIBIDO: 2,
} as const

export type TipoPrestamoType =
  (typeof TIPO_PRESTAMO)[keyof typeof TIPO_PRESTAMO]
